export const shoppingTipsArticleId = 207;
